import { useSelector } from 'react-redux';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { EndpointKey } from '../http/EndpointKey';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { getSignupGtkmDataEntries } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { getDataKeysByStep } from '../step/getStepData';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
export const useGTKMSingleFieldReturned = () => {
  var _gtkmData$find;
  const {
    currentStep
  } = useCurrentStep();
  const dataKeys = getDataKeysByStep([currentStep]);
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.never);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const isAssignedToACQ173VariantAorC = isAssignedToACQ173VariantA || isAssignedToACQ173VariantC;
  const gtkmEndpointRetries = useSelector(state => getEndpointRetries(state, EndpointKey.GTKMCompanyInfo));
  const gtkmData = useSelector(state => getSignupGtkmDataEntries(state));
  let gtkmOneFieldReturned = false;
  const gtkmNonDomainKey = gtkmData.length === 2 ? ((_gtkmData$find = gtkmData.find(([key]) => key !== Data.CompanyDomain)) === null || _gtkmData$find === void 0 ? void 0 : _gtkmData$find[0]) || null : null;
  if (isAssignedToACQ173VariantAorC && gtkmNonDomainKey && dataKeys.includes(gtkmNonDomainKey) && gtkmEndpointRetries === 1) {
    gtkmOneFieldReturned = true;
  }
  return {
    gtkmOneFieldReturned,
    gtkmNonDomainKey
  };
};